// extracted by mini-css-extract-plugin
export default {"container":"TypeForm_container__6CeiO","card":"TypeForm_card__92Xqp","title":"TypeForm_title__Fy+88"};